// import '../App.css';
// import logo from '../assets/images/logo-temp.png';

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "../App.css";

function Footer() {
  const [data, setData] = useState(null);

  useEffect(() => {
    // Replace 14 with your actual page ID
    fetch("https://family-barbers.com/wp-json/acf/v3/pages/14")
      .then((res) => res.json())
      .then((json) => setData(json.acf))
      .catch((err) => console.error("Error fetching ACF data:", err));
  }, []);

  if (!data) return null;

  return (
    <div id="footer" className="section">
      <div className="footer-parent-container">
        {data.footer_logo && (
          <motion.img
            src={data.footer_logo.url}
            alt={data.footer_logo.alt || "Logo"}
            initial={{ x: -200, opacity: 0 }}  // smaller offset for reliability
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          />


        )}

        <div className="footer-div">
          <h2>{data.footer_phone_label || "Phone Number"}</h2>
          <p>{data.footer_phone || "(905) 232-8748"}</p>
        </div>

        <div className="footer-div">
          <h2>{data.footer_email_label || "Email"}</h2>
          <p>{data.footer_email || "Familybarbers905@gmail.com"}</p>
        </div>

        <div className="footer-div">
          <h2>{data.footer_address_label || "Shop Address"}</h2>
          <p>{data.footer_address || "34A Dundas St E, Mississauga, ON"}</p>
        </div>
      </div>
    </div>
  );
}

export default Footer;

